/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getCheckout'

export { $nsid }

/** @deprecated please use com.atproto.sync.getRepo instead */
const main = l.query(
  $nsid,
  l.params({ did: l.string({ format: 'did' }) }),
  l.payload('application/vnd.ipld.car'),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
